var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-layout',[_c('overview-description',[_c('h2',[_vm._v("Notifications Overview")]),_vm._v(" "),_c('p',[_vm._v("The notifications overview shows you things which require your attention or action")])]),_vm._v(" "),_c('notifications')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0104effe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/Notifications.vue
// module id = 890
// module chunks = 0